import {
  isPlainObject as _isPlainObject,
  isEmpty as _isEmpty,
  isArray as _isArray,
  trim as _trim,
} from 'lodash'


/** 값이 같으면 null 다르면 원래값 */
function fnEqNullValue(orgValue, exceptValue) {
  // noinspection EqualityComparisonWithCoercionJS
  return orgValue == exceptValue ? null : orgValue
}

/** orgMap 에서 nullMap 하고 같은 값은 null 로 변경 */
function fnEqNullMap(orgMap, nullMap) {
  const retMap = {}
  for (const k in orgMap) {
    // noinspection EqualityComparisonWithCoercionJS
    retMap[k] = orgMap[k] == nullMap[k] ? null : orgMap[k]
  }
  return retMap
}

/**
 * 입력된 url의 query 를 변경한다.
 * 만약 value 를 null 로 하면 해당 키가 삭제된다.
 * 해당 key 는 유지하고 value 만 없애고 싶으면 value 에 '' 를 입력하면 된다.
 * @param url
 * @param queryMap
 * @returns {string}
 */
function fnUrlQueryChange(url, queryMap) {
  if (url === null || url === undefined) {
    url = ''
  }
  if (queryMap && typeof (queryMap) === 'object') {
    for (const k in queryMap) {
      const v = queryMap[k]
      url = url.replace(new RegExp("([?&])" + k + "=[^&]*&?", "g"), "$1")
      if (v !== null && v !== undefined) {
        url = url.replace(/[&?]+$/, '')
        url += url.indexOf("?") < 0 ? "?" : "&"
        url += k + "=" + encodeURIComponent(v)
      }
    }
  }
  url = url.replace(/[&?]+$/, '')
  return url
}


/**
 * 현재 URL 의 query 를 변경한다.
 * ex) fnUpdateUrlQuery({tabType: 'notice', pageNum: 3})
 * @param queryMap
 * @param isPush
 */
function fnLocationBarChangeQuery(queryMap, isPush = false) {
  const url = fnUrlQueryChange(location.href, queryMap)
  fnLocationBarChangeUrl(url, isPush)
}

function fnLocationBarChangeQueryDefault(queryMap, defaultMap, isPush = false) {
  fnLocationBarChangeQuery(fnEqNullMap(queryMap, defaultMap), isPush)
}

/**
 * 현재 화면의 URL 을 업데이트한다. 실제로 이동하진 않는다.
 * @param url
 * @param isPush (기본 false) 페이지를 이동한 것처럼
 */
function fnLocationBarChangeUrl(url, isPush = false) {
  if (typeof history.pushState !== "function") {
    console.warn("현재 웹브라우져는 history 모드를 지원하지 않습니다.")
    return
  }
  if (isPush) {
    history.pushState({}, '', url)
  } else {
    history.replaceState({}, '', url)
  }
}

function ifNaN(obj, defaultNum = 0) {
  return isNaN(obj) ? defaultNum : obj
}


function toNumber(obj, defaultVal = null) {
  return isNU(obj) ? defaultVal
    : typeof obj === 'number' ? obj
      : typeof obj === 'string' ? ifNaN(Number(obj), defaultVal)
        : defaultVal
}


const convertDefineMap = {
  number: (v) => toNumber(v),
  comma_array: (str) => {
    if (isBlank(str)) return []
    if (("" + str)?.indexOf(',') >= 0) {
      const ar = str.trim().split(/\s*,\s*/)
      return ar.reduce((t, p) => {
        t.push(p);
        return t
      }, [])
    } else {
      return [str.trim()]
    }
  },
  comma_number_array: (str) => {
    if (isBlank(str)) return []
    if (("" + str)?.indexOf(',') >= 0) {
      const ar = str.trim().split(/\s*,\s*/)
      return ar.reduce((t, p) => {
        t.push(toNumber(p));
        return t
      }, [])
    } else {
      return [toNumber(str.trim())]
    }
  }
}

/**
 * queryString 을 map 으로 변환<pre>
 *   값의 타입변환이 필요한경우 지정가능
 *
 *   현재 사용 가능한 함수
 *     number              : 숫자로 변환
 *     comma_number_array  : 콤마숫자문장을 배열로 변환 2,5,6 -> [2,5,6]
 *     comma_array         : 콤마구분을 배열로 변환 aaa,bbb,ccc -> ['aaa','bbb','ccc']
 *
 *   const qs_map = queryStringToMap({
 *     no: 'number',
 *     s_class_list: 'comma_number_array',
 *   })</pre>
 * @param {{}} convOpt 키별 값 형태 지정
 * @returns {any}
 */
function queryStringToMap(convOpt = {}) {
  const qs = location.search.slice(1);

  const pairs = qs.split("&");
  const result = {};

  pairs.forEach(p => {
    const pair = p.split("=");
    const key = pair[0];
    if (isEmpty(key)) return

    let value = decodeURIComponent(pair[1] || "");

    // 값 타입 변환
    const fnName = convOpt[key];
    if (fnName) { // 변환대상인 경우
      const convFN = convertDefineMap[fnName]
      if (!convFN) throw new Error('변환 함수가 없습니다. - 컬럼 = ' + key + ', 함수명 = ' + fnName)
      value = convFN(value)
    }

    if (result[key] !== undefined) { // 이미 키가 있다면
      if (_isArray(result[key])) { // 그게 배열이면
        result[key].push(value); // 뒤에 추가
      } else { // 아니라면 ( === 두번재 등록이라면 )
        result[key] = [result[key], value]; // 배열로 만든다.
      }
    } else {
      result[key] = value;
    }
  });

  return result
}

function isNU(obj) {
  return obj === null || obj === undefined
}

/**
 * 눈에 보이는 기준으로 not empty 인지 확인<pre>
 *   isNotEmpty(null)      === false
 *   isNotEmpty(undefined) === false
 *   isNotEmpty("")        === false
 *   isNotEmpty(" ")       === true
 *   isNotEmpty(0)         === true
 *   isNotEmpty(1)         === true
 *   isNotEmpty(true)      === true  // boolean 타입은 무조건 not empty
 *   isNotEmpty(false)     === true  // boolean 타입은 무조건 not empty
 *   isNotEmpty({})        === false
 *   isNotEmpty([])        === false
 *   기타 알수없는 타입      === false
 * </pre>
 * @param {string} str
 * @returns {boolean}
 */
function isNotEmpty(str) {
  if (isNU(str)) return false  // null 이거나 undefined 라면 무조건 false
  if (typeof str === 'string') return str.length > 0 // 문장이면 길이가 0보다 클때
  if (typeof str === 'number') return str != 0 // 숫자인 경우 0이 아닐때
  if (typeof str === 'boolean') return true // boolean 타입은 무조건 true
  if (Array.isArray(str)) return str.length > 0 // 배열이면 길이가 0보다 클때
  if (_isPlainObject(str)) return !_isEmpty(str) // 맵 형태인 경우 데이터가 있나 확인
  return false // 기타 알수없는 타입인경우 무조건 false
}

function isEmpty(obj) {
  return !isNotEmpty(obj)
}

function isBlank(str) {
  return isEmpty(_trim(str))
}

function isNotBlank(str) {
  return !isBlank(str)
}

function ifBlank(str, defaultStr) {
  return isNotBlank(str) ? str : defaultStr
}


function objTrace(obj) {
  if (obj === undefined || obj === null) return null;
  for (const key in obj) {
    const vtype = typeof (obj[key])
    if (key === "_events") continue;
    if (vtype === "function") continue;
    let value = "";
    try {
      if (vtype === 'function') {
        value = "(function)"
      } else {
        value = "" + obj[key];
      }
    } catch (e) {
      value = 'error'
    }
    if (value.length > 100) value = value.substring(0, 100);
    console.log(key + ` = [${vtype}]`, value);
  }
}


export default {
  fnPrintDate: function (_date) {

    let _month = _date.getMonth();
    _month = "0" + (_month + 1);
    let _day = "0" + _date.getDate();

    return _date.getFullYear() + "-" + _month.substring(_month.length - 2, _month.length) + "-" + _day.substring(_day.length - 2, _day.length);

  },

  fnPrintDateByNum: function (_date) {
    if (_date != null && _date != "") {
      let year = _date.substring(0, 4);
      let month = _date.substring(4, 6);
      let day = _date.substring(6, 8);
      return year + "-" + month + "-" + day;
    }
    return "";
  },

  fnConvertStrDate: function (str, exp) {
    let year;
    let month;
    let day;
    if (exp == null) {
      year = str.substring(0, 4);
      month = str.substring(4, 6);
      day = str.substring(6, 8);
    } else {
      str = str.split(exp);
      year = str[0];
      month = str[1];
      day = str[2];
    }
    return new Date(year, month, day);
  },

  fnConvertDateStr: function (paramDate, exp) {
    let _date = new Date(paramDate);
    let month = _date.getMonth() + 1;
    let day = _date.getDate();
    let year = _date.getFullYear();
    let _month = month < 10 ? "0" + month : month;
    let _day = day < 10 ? "0" + day : day;
    if (exp == null) {
      return year + "/" + _month + "/" + _day;
    } else {
      return year + exp + _month + exp + _day;
    }
  },

  fnOnFileDownload: function (seq) {
    window.location = '/file/download/' + seq;
  },
  fnConvertDateDayeStr: function (_date, exp) {
    if (_date == null) {
      return '';
    }

    if (typeof _date == 'string') {
      let _yy = _date.substring(0, 4);
      let _mm = _date.substring(4, 6);
      let _dd = _date.substring(6, 8);
      let date = _yy + exp + _mm + exp + _dd;
      return date;
    }
  },
  fnConvertDateTimeStr: function (_date, exp) {
    if (_date == null) {
      return '';
    }

    let dt = new Date(_date);

    if (typeof _date == 'string') {
      let _splitDate = _date.split(' ');
      let _yymmdd = _splitDate[0].split('-');
      let _hhmmss = _splitDate[1].split(':');
      dt = new Date(_yymmdd[0], _yymmdd[1] - 1, _yymmdd[2], _hhmmss[0], _hhmmss[1], _hhmmss[2]);
    }

    let month = dt.getMonth() + 1;
    let day = dt.getDate();
    let year = dt.getFullYear();
    let hh = dt.getHours();
    let min = dt.getMinutes();
    let ss = dt.getSeconds();
    day = day < 10 ? "0" + day : day;
    hh = hh < 10 ? "0" + hh : hh;
    min = min < 10 ? "0" + min : min;
    ss = ss < 10 ? "0" + ss : ss;
    let _month = month < 10 ? "0" + month : month;
    if (exp == null) {
      return year + "/" + _month + "/" + day + " " + hh + ":" + min + ":" + ss;
    } else {
      return year + exp + _month + exp + day + " " + hh + ":" + min + ":" + ss;
    }
  },

  toDay_YYYYMMDD: function (n) {
    let now = new Date();
    if (n != undefined && n != null) {
      now.setDate(now.getDate() + parseInt(n))
    }
    let y = now.getFullYear();
    let m = now.getMonth() + 1;
    let d = now.getDate();
    return '' + y + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d;
  },

  toDay_MMDD: function (paramDate) {
    let _date = new Date(paramDate);
    let month = _date.getMonth() + 1;
    let day = _date.getDate();
    let _month = month < 10 ? "0" + month : month;
    let _day = day < 10 ? "0" + day : day;

    return _month + '-' + _day;
  },

  fnConvertStrPrintDateByNum: function (_date) {
    if (_date != null && _date != "") {
      let date = _date.replace("-", "");
      let year = date.substring(0, 4);
      let month = date.substring(4, 6);
      let day = date.substring(6, 8);
      return year + "-" + month + "-" + day;
    }
    return "";
  },

  fnNumberFormat: function (inputNumber) {
    return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  fnGrpSendYnCode: function () {
    const _list = [{code: "1", value: "수신"}, {code: "2", value: "미수신"}];
    return _list;
  },
  fnGrpAgreeYnCode: function () {
    const _list = [{code: "1", value: "동의"}, {code: "0", value: "미동의"}];
    return _list;
  },
  fnBrdOrderingCode: function () {
    const _list = [{code: "1", value: "최신순"}, {code: "2", value: "인기순"}];
    return _list;
  },
  //시설관리 셀렉트박스 코드
  fnFacSelectKindCode: function () {
    const _list = [{code: "all", value: "전체"}, {code: "title", value: "제목"}, {code: "content", value: "내용"}];
    return _list;
  },
  // 상태(결제상태)
  fnStatusCode: function () {
    const _list = [{code: "all", value: "전체"}, {code: "ready", value: "접수전"}, {
      code: "wait",
      value: "대기신청"
    }, {code: "approve", value: "신청완료"}, {code: "complete", value: "이수"}];
    return _list;
  },
  // 상태(결제)
  fnPaymentCode: function () {
    const _list = [{code: "all", value: "전체"}, {code: "Y", value: "결제완료"}, {code: "N", value: "미결제"}, {
      code: "NO",
      value: "결제없음"
    }];
    return _list;
  },
  fnGetCurrentDate: function () {
    let _date = new Date();
    let _yyyy = _date.getFullYear();
    let _mm = _date.getMonth() + 1;
    let _dd = _date.getDate();
    let _finalmm = (_mm < 10) ? "0" + _mm : _mm;
    let _finaldd = (_dd < 10) ? "0" + _dd : _dd;
    let _current = _yyyy + '-' + _finalmm + "-" + _finaldd;
    return _current;
  },
  fnGetCurrentParamDate: function (date, split) {
    let _date = date.split(split);
    if (_date.length > 0) {
      let _yyyy = _date[0];
      let _mm = _date[1];
      let _dd = _date[2];
      return _yyyy + _mm + _dd;
    }
  },
  //특정 월요일과 일요일의 날짜 구함
  fnGetWeekDayNonFilter: function (_date, isMonday) {

    let _vn_day = new Date(_date);
    let _day = _vn_day.getDay();
    let _last_day = new Date(_vn_day.getFullYear(), _vn_day.getMonth(), 0);
    let _mon = _vn_day.getDate() - _day + (_day == 0 ? -6 : isMonday);
    console.log(_vn_day, isMonday, _date, _mon, _last_day.getDate(), );
    let _newDt = new Date(_vn_day.setDate(_mon));
    //let _monDate = new Date(_vn_day.setDate(_mon).getFullYear(), _vn_day.setDate(_mon).getMonth(), _vn_day.setDate(_mon).getDay());
    let _monDate = _newDt.getFullYear() + "." + (_newDt.getMonth() + 1).toString().padStart(2, '0') + "." + _newDt.getDate().toString().padStart(2, '0');
    return _monDate;

    //let _finalDate = _monDate.replace(/-/g, '.');
    //return _finalDate
  },
  fnGetWeekToDay: function (_date, filter) {

    let _vn_day = new Date(_date);
    let _day = _vn_day.getDay();
    let _mon = _vn_day.getDate();
    let _monDate = new Date(_vn_day.setDate(_mon)).toISOString().substring(0, 10);
    let _finalDate = _monDate.replace(/-/g, filter);
    return _finalDate
  },
  fnGetWeekDay: function (_date, isMonday, filter) {

    let _vn_day = new Date(_date);

    let _day = _vn_day.getDay();
    let _mon = _vn_day.getDate() - _day - (_day == 0 ? -6 : isMonday);
    let _monDate = new Date(_vn_day.setDate(_mon)).toISOString().substring(0, 10);
    let _finalDate = _monDate.replace(/-/g, filter);
    return _finalDate
  },
  fnNumberWithComma: function (_value) {
    return _value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  objTrace,
  fnEqNullValue,
  fnEqNullMap,
  fnLocationBarChangeQuery,
  fnLocationBarChangeQueryDefault,
  fnUrlQueryChange,
  fnLocationBarChangeUrl,

  queryStringToMap,
  isBlank, isNotBlank, ifBlank,
}
